import { createFromIconfontCN } from '@ant-design/icons-vue'
import { defineComponent, type PropType } from 'vue'
const FileIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2647415_c8rps4hyyz.js' // 在 iconfont.cn 上生成
})

export default defineComponent({
  props: {
    type: {
      type: String as PropType<string>,
      default: ''
    }
  },
  setup(props) {
    return () => <FileIcon type={props.type} />
  }
})
